const Style = {

  app: 'p-6 min-h-full bg-slate-50 sm:pl-24'

}

export default Style;